import { paths } from '../paths';
import { lazyLoadPage } from '../utils';

export const collectionRoutes = [
  {
    path: paths.COLLECTIONS(),
    element: lazyLoadPage('/collections', { path: '(dashboard)' }),
    state: {
      pageKey: 'collections',
      metadata: {
        title: 'Collections'
      }
    }
  },
  {
    path: paths.COLLECTIONS_SAVED(),
    element: lazyLoadPage('/collections/saved', { path: '(dashboard)' }),
    state: {
      pageKey: 'collections-saved',
      metadata: {
        title: 'Saved Collections'
      }
    }
  },
  {
    path: paths.COLLECTIONS_FEATURED(),
    element: lazyLoadPage('/collections/featured', { path: '(dashboard)' }),
    state: {
      pageKey: 'collections-featured',
      metadata: {
        title: 'Featured Collections'
      }
    }
  },
  {
    path: paths.COLLECTIONS_DETAIL(),
    element: lazyLoadPage('/collections/[collectionId]', { path: '(dashboard)' }),
    state: {
      pageKey: 'collections-detail',
      metadata: {
        title: 'Collection detail'
      },
      shoppingCart: {
        enabled: false
      }
    }
  },
  {
    path: paths.COLLECTIONS_DETAIL_EDIT(),
    element: lazyLoadPage('/collections/[collectionId]/edit', { path: '(dashboard)' }),
    state: {
      pageKey: 'collections-detail-edit',
      metadata: {
        title: 'Edit Collections'
      },
      shoppingCart: {
        enabled: false
      }
    }
  }
];
